module.exports = __webpack_public_path__ + "img/3.dfb6cc15.png";